export default __webpack_public_path__ + "static/tim-martin-case-study-foto-aa57e85e721dd0f321051b9337db83cc.png";